import { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from 'redesign/components/app/AppLayout';
import WithAuthentication from 'redesign/components/common/WithAuthentication';

const Login = lazy(() => import('redesign/pages/Login'));
const SSORedirectPage = lazy(() => import('redesign/pages/SSORedirect'));
const ForgotPassword = lazy(() => import('redesign/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('redesign/pages/ResetPassword'));
const Privacy = lazy(() => import('redesign/pages/Privacy'));
const SetPassword = lazy(() => import('pages/login/SetPassword'));
const Main = lazy(() => import('redesign/components/main/Main'));

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<AppLayout />}>
                <Route path="/" element={<Navigate to="home" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot_password" element={<ForgotPassword />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/signup" element={<SetPassword />} />
                <Route path="/reset" element={<ResetPassword />} />
                <Route path="/sso-redirect" element={<SSORedirectPage />} />
                <Route path="/*" element={<WithAuthentication component={Main} />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
}

export default AppRoutes;
